module.exports = __webpack_public_path__ + "static/media/media_november.8c014e42.pdf";